/**
 * @fileoverview GitHub API Service
 * @description Service for interacting with GitHub API through Python backend
 * @module services/api/github
 */

import { apiClient } from './client';

/**
 * GitHub API Service
 * Provides methods to interact with GitHub data through the backend API
 */
export const githubApi = {
  /**
   * Get health status of GitHub API service
   * @returns {Promise<Object>} Health status
   */
  getHealth: async () => {
    return apiClient.get('/v1/github/health');
  },

  /**
   * Get branches for a repository
   * @param {string} org - Organization name
   * @param {string} repo - Repository name
   * @returns {Promise<Object>} Repository branches data
   */
  getBranches: async (org, repo) => {
    return apiClient.get(`/v1/github/repos/${org}/${repo}/branches`);
  },

  /**
   * Get GitHub Copilot metrics for an organization
   * @param {string} org - Organization name
   * @returns {Promise<Object>} Copilot metrics data
   */
  getCopilotMetrics: async (org) => {
    return apiClient.get(`/v1/github/orgs/${org}/copilot/metrics`);
  },

  /**
   * Get repository details
   * @param {string} org - Organization name
   * @param {string} repo - Repository name
   * @returns {Promise<Object>} Repository details
   */
  getRepository: async (org, repo) => {
    return apiClient.get(`/v1/github/repos/${org}/${repo}`);
  },

  /**
   * Get all repositories in an organization
   * @param {string} org - Organization name
   * @returns {Promise<Object>} Organization repositories data
   */
  getOrgRepositories: async (org) => {
    return apiClient.get(`/v1/github/orgs/${org}/repos`);
  },
};

export default githubApi;
